import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useContext } from "react";
import { Collapse } from "react-bootstrap";
import { MyContext } from "../config/config";
const Sidebar = ({ isOpen, setIsOpen }) => {
  const { affiliateRequest, setAffiliateRequest, openLoad, setOpenLoad } =
    useContext(MyContext);
  const [sidebarOpenMobile, setSidebarOpenMobile] = useState(false);

  const location = useLocation();
  useEffect(() => {
    if (location.pathname == "/users") {
    }
    if (location.pathname.split("/")[1] == "PrimaryClient") {
      localStorage.setItem("tab", "primary");
    } else if (location.pathname.split("/")[1] == "UserList") {
      localStorage.setItem("tab", "users");
    } else if (
      location.pathname.split("/")[1] !== "userInfo" &&
      location.pathname.split("/")[1] !== "PrimaryClient" &&
      location.pathname.split("/")[1] !== "UserList"
    ) {
      localStorage.removeItem("tab");
    }
    if (location.pathname.split("/")[1] == "LoadManagement") {
      setOpenLoad(true);
    } else {
      setOpenLoad(false);
    }
  }, [location.pathname]);

  return (
    <>
      <div className="sidebar-overlay">
        <div
          onClick={() => setSidebarOpenMobile(!sidebarOpenMobile)}
          className={`${sidebarOpenMobile ? "sidebar-cross-btn" : "sidebar-toggle-btn"
            } `}
        >
          <img
            src={
              sidebarOpenMobile
                ? require("../assets/images/sidebar-cross.svg").default
                : require("../assets/images/sidebar-menu.svg").default
            }
            alt="img"
          />
        </div>

        <section className="sidebar">
          <div className="logo">
            <img src={require("../assets/images/logo.png")} alt="" />
          </div>
          <div className="">
            <Link
              to="/Home"
              className={
                location.pathname == "/Home"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Dashboard
            </Link>

            <Link
              to="/users"
              onClick={() => localStorage.setItem("tab", "users")}
              className={
                (localStorage.getItem("tab") == "users" &&
                  location.pathname == "/users") ||
                  (localStorage.getItem("tab") == "users" &&
                    location.pathname.split("/")[1] == "userInfo") ||
                  location.pathname == "/users"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img src={require("../assets/images/audit.svg").default} alt="" />
              User Management
            </Link>

            {/* <Link
              to="/banned-users"
              className={
                location.pathname == "/banned-users"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img src={require("../assets/images/audit.svg").default} alt="" />
              Banned Users
            </Link> */}

            <Link
              to="/tournaments"
              onClick={() => localStorage.setItem("tab", "tournaments")}
              className={
                (localStorage.getItem("tab") == "tournaments" &&
                  location.pathname == " /tournaments") ||
                  (localStorage.getItem("tab") == "tournaments") ||
                  location.pathname == "/tournaments"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img src={require("../assets/images/audit.svg").default} alt="" />
            Tournament
            </Link>

              {/* ----Banner Mangement---- */}
            <Link
                to="/banner"
                className={
                  location.pathname == "/banner"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Banner Management
              </Link>
            <Link
                to="/banner-report"
                className={
                  location.pathname == "/banner-report"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Banner Report
              </Link>
            
            <Link
              to="/predictions"
              className={
                location.pathname == "/predictions" ||
                  location.pathname.split("/")[1] == "prediction-detail"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Prediction Management
            </Link>

            <Link
              to="/profile-questions"
              className={
                location.pathname === "/profile-questions"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
            
              <img
                src={require("../assets/images/profile-question.svg").default}
                alt=""
              />
              Profile Questions
            </Link>

            <Link
              to="/maximum-gas-fee"
              className={
                location.pathname == "/maximum-gas-fee" 
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Set Maximum Gas Fee
            </Link>

            <Link
              to="/bets-won"
              className={
                location.pathname == "/bets-won" ||
                  location.pathname.split("/")[1] == "/bets-won"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Bets Won
            </Link>

            <Link
              to="/whitelist"
              className={
                location.pathname == "/whitelist" ||
                  location.pathname.split("/")[1] == "/whitelist"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Whitelist
            </Link>


            <Link
              to="/pro-membership"
              className={
                location.pathname == "/pro-membership" ||
                  location.pathname.split("/")[1] == "/pro-membership"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Pro Membership
            </Link>

            <Link
              to="/plan-payments"
              className={
                location.pathname == "/plan-payments" ||
                  location.pathname.split("/")[1] == "plan-payments"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Plan Payments
            </Link>

            <Link
              to="/benjamin-NFT-updates"
              className={
                location.pathname == "/benjamin-NFT-updates" ||
                  location.pathname.split("/")[1] == "/benjamin-NFT-updates"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Update Benjamin NFTs
            </Link>

             <Link
              to="/crypto-gift-store"
              className={
                location.pathname == "/crypto-gift-store" ||
                  location.pathname.split("/")[1] == "/crypto-gift-store"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Crypto Gift Store
            </Link>
            {/* ---Redemption--- */}
             <Link
              to="/redemption-history"
              className={
                location.pathname == "/redemption-history" ||
                  location.pathname.split("/")[1] == "/redemption-history"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Redemption History
            </Link>
            <Link
              to="/solo-predictions"
              className={
                location.pathname == "/solo-predictions" ||
                  location.pathname.split("/")[1] == "solo-detail"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Solo Templates
            </Link>

            <Link
              to="/group-templates"
              className={
                location.pathname == "/group-templates" ||
                  location.pathname.split("/")[1] == "group-template-detail"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Group Templates
            </Link>

            <Link
              to="/scores-prediction-result-failed"
              className={
                location.pathname == "/scores-prediction-result-failed" 
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
            Scores Prediction Result Failed
            </Link>

            <Link
              to="/multichoice-prediction-templates"
              className={
                location.pathname == "/multichoice-prediction-templates" ||
                  location.pathname.split("/")[1] == "multichoice-prediction-template-detail"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Multi Choice Prediction Templates
            </Link>

            <Link
              to="/freegroup-prediction-templates"
              className={
                location.pathname == "/freegroup-prediction-templates" ||
                  location.pathname.split("/")[1] == "freegroup-prediction-template-detail"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
             Free Group Templates
            </Link>

              {/* ----pAyPal Orders------ */}
            <Link
              to="/paypal-orders"
              className={
                location.pathname == "/paypal-orders" 
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Paypal Orders
            </Link>

            <Link
              to="/failed-transactions"
              className={
                location.pathname == "/failed-transactions" 
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
            Failed Transactions
            </Link>

            {/* <Link
              to="/result_failed-transactions"
              className={
                location.pathname == "/result_failed-transactions" 
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
            Result Failed Transactions
            </Link> */}



            <Link
              to="/transaction"
              className={
                location.pathname == "/transaction"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/transaction-new.svg").default}
                alt=""
              />
              Transaction Management
            </Link>
          
            <Link
              to="/contact-us"
              className={
                location.pathname == "/contact-us" ||
                  location.pathname.split("/")[1] == "contact-us"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/contact-us.svg").default}
                alt=""
              />
              Contact Us
            </Link>
            {/* <Link
              to="/twitter-usage"
              className={
                location.pathname == "/twitter-usage"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Twitter API Usage
            </Link> */}
            {/* <Link
              to="/twilio-responses"
              className={
                location.pathname == "/twilio-responses"
                  ? "sidebar_option active"
                  : "sidebar_option"
              }
            >
              <img
                src={require("../assets/images/dashboard.svg").default}
                alt=""
              />
              Twilio Responses
            </Link> */}
          </div>
        </section>

        {sidebarOpenMobile && (
          <section className="sidebar sidebar-mobile">
            {/* <div className="logo">
              <img src={require("../assets/images/front-logo.png")} alt="" />
            </div> */}
            <div className="">
              <Link
                to="/Home"
                className={
                  location.pathname == "/Home"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Dashboard
              </Link>

              <Link
                to="/users"
                onClick={() => localStorage.setItem("tab", "users")}
                className={
                  (localStorage.getItem("tab") == "users" &&
                    location.pathname == "/users") ||
                    (localStorage.getItem("tab") == "users" &&
                      location.pathname.split("/")[1] == "userInfo") ||
                    location.pathname == "/users"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img src={require("../assets/images/audit.svg").default} alt="" />
                User Management
              </Link>
              <Link
                to="/banned-users"
                className={
                  location.pathname == "/banned-users"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img src={require("../assets/images/audit.svg").default} alt="" />
                Banned Users
              </Link>
              <Link
                to="/predictions"
                className={
                  location.pathname == "/predictions" ||
                    location.pathname.split("/")[1] == "prediction-detail"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Prediction Management
              </Link>

              <Link
                to="/maximum-gas-fee"
                className={
                  location.pathname == "/maximum-gas-fee"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Set Maximum Gas Fee
              </Link>
              <Link
                to="/solo-predictions"
                className={
                  location.pathname == "/solo-predictions" ||
                    location.pathname.split("/")[1] == "solo-detail"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Solo Predictions
              </Link>

              <Link
                to="/transaction"
                className={
                  location.pathname == "/transaction"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/transaction-new.svg").default}
                  alt=""
                />
                Transaction Management
              </Link>
              <Link
                to="/failed-transactions"
                className={
                  location.pathname == "/failed-transactions"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/transaction-new.svg").default}
                  alt=""
                />
                Failed Transaction
              </Link>
              <Link
                to="/plan-payments"
                className={
                  location.pathname == "/plan-payments"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Plan Payments
              </Link>
              <Link
                to="/banner"
                className={
                  location.pathname == "/banner"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Banner Management
              </Link>
              <Link
                to="/contact-us"
                className={
                  location.pathname == "/contact-us" ||
                    location.pathname.split("/")[1] == "contact-us"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/contact-us.svg").default}
                  alt=""
                />
                Contact Us
              </Link>
              {/* <Link
                to="/twitter-usage"
                className={
                  location.pathname == "/twitter-usage"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Twitter API Usage
              </Link> */}
              {/* <Link
                to="/twilio-responses"
                className={
                  location.pathname == "/twilio-responses"
                    ? "sidebar_option active"
                    : "sidebar_option"
                }
              >
                <img
                  src={require("../assets/images/dashboard.svg").default}
                  alt=""
                />
                Twilio Responses
              </Link> */}
            </div>
          </section>
        )}
      </div>
    </>
  );
};
export default Sidebar;
